// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"008b3be8","557":"60188150","787":"2e5c13b0"}[chunkId] + ".chunk.js";
};